import { render, staticRenderFns } from "./BidderEvaluationView.vue?vue&type=template&id=21ae3db4&scoped=true&"
import script from "./BidderEvaluationView.vue?vue&type=script&lang=js&"
export * from "./BidderEvaluationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ae3db4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
